import React, {useState} from 'react'
import {
    Card,
    Button,
    Tabs,
    Form,
    Input,
    notification,
} from 'antd';
import service from "../api/FetchInterceptor";
import {useUserStore} from "../store/userStore";

const UpdatePassword = () => {
    const { user : currentUser } = useUserStore();

    const [loading, setLoading] = useState(false)

    const upgradePassword = (values) => {
        setLoading(true)

        service({
            method: 'POST',
            url: `user/${currentUser.id}/update-password/`,
            data: values
        }).then((response) => {
            notification.success({
                message: response.message
            })
        }).finally(() => {
            setLoading(false)
        })
    }

    return <>
        <Form onFinish={upgradePassword} layout={"horizontal"}>
            <Form.Item
                label="Nouveau mot de passe"
                name="password"
                rules={[{ required: true, message: 'Veuillez entrer un mot de passe.' }]}
            >
                <Input.Password />
            </Form.Item>

            <Form.Item
                name="password_confirmation"
                label="Confirmation du mot de passe"
                dependencies={['password']}
                rules={[
                    { required: true, message: 'Veuillez confirmer votre mot de passe.' },
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            if (!value || getFieldValue('password') === value) {
                                return Promise.resolve();
                            }
                            return Promise.reject(new Error('Les mots de passe ne correspondent pas.'));
                        },
                    }),
                ]}
            >
                <Input.Password />
            </Form.Item>

            <Button loading={loading} htmlType={'submit'} type={"primary"}>Modifier</Button>
        </Form>
    </>
}

const Profile = () => {
    const { user : currentUser } = useUserStore();

    return (
        <>
            <div className="container my-4">
                <Card>
                    <Tabs
                        defaultActiveKey="updatePassword"
                        items={[
                            {
                                label: `Modification de mot de passe`,
                                key: 'update-password',
                                children: <UpdatePassword />,
                            }
                        ]}
                    />
                </Card>
            </div>
        </>
    )
}

export default Profile